// extracted by mini-css-extract-plugin
export default {"hint":"FormHint_hint__imA1A","error":"FormHint_error__WnYha"};